import dlUrl from './urlConfig.js'

//判断是否PC
export function judge() {
    window.console.log('navigator.userAgent', navigator.userAgent.toLowerCase())
    window.console.log(window.screen.width,window.screen.height)
    var userAgentInfo = navigator.userAgent.toLowerCase();
    var Agents = ["android", "iphone", "symbianos", "windows phone", "ipad", "ipod","mac os"];
    var flag = true;
    for (var v = 0; v < Agents.length; v++) {
        if(userAgentInfo.indexOf(Agents[v]) > 0) {
            if (Agents[v] === 'mac os') { //区分ipad和mac
                if (window.screen.width > window.screen.height) {
                    return true;
                } else { 
                    return false;
                }
            }
            return false;
        }
    }
    return flag;
}
//设置meta信息
export function setMeta() {
    if (dlUrl.appId == 2 || dlUrl.appId == 3) {
        let ogTitle = document.querySelector('#ogTitle')
        let title = document.querySelector('#title')
        let ogImage = document.querySelector('#ogImage')


        ogTitle.content = "Tlink";
        title.innerHTML = 'Tlink官方网站'
        ogImage.content = "https://tLink.getech.cn/logo.png"
    }
}